import PropTypes from 'prop-types';
import styles from './FJUploadAudioToClone.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJUploadBorderIcon from '../../../assets/svg/upload-border-normal.svg?react';
import FJUploadBorderHoverIcon from '../../../assets/svg/gradient-border.svg?react';
import FJUploadIcon from '../../../assets/svg/ttv/clone-file.svg?react';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJBrowseIcon from '../../../assets/svg/ttv/browse-file.svg?react';
import FJRecordIcon from '../../../assets/svg/ttv/record.svg?react';
import {
    UPLOAD_FILE_TYPE_OF_AUDIO,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_AUDIOS,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
} from '../../../config/dataConfig/FJGenerateData.js';
import { useState } from 'react';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload.jsx';
import classNames from 'classnames';
import FJBackArrowIcon from '../../../assets/svg/back-arrow.svg?react';
import FJAutoLoading from '../../../common/components/FJLoading/FJAutoLoading.jsx';
import FJBorderButton from '../../../common/components/FJButton/FJBorderButton.jsx';

const FJUploadAudioToClone = props => {
    const { uploadAudioInVoiceClone, openRecord, onBack, hasHistoryList, isUploading } = props;
    const [isDraggingFile, setIsDraggingFile] = useState(false);

    const _dragCallback = type => {
        setIsDraggingFile(type === 'over');
    };

    const _openRecord = e => {
        e.stopPropagation();
        openRecord();
    };

    return (
        <>
            {hasHistoryList && (
                <div className={styles.back} onClick={onBack}>
                    <FJBackArrowIcon />
                    {FJLocalStore._('back')}
                </div>
            )}
            <div className={styles.title}>{FJLocalStore._('create-voice-clone')}</div>
            <FJFileUpload
                className={classNames(
                    styles.upload_box,
                    isDraggingFile ? styles.active : '',
                    isUploading ? styles.loading : '',
                )}
                accept={
                    UPLOAD_FILE_TYPE_OF_AUDIO +
                    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_AUDIOS +
                    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS
                }
                onUpload={uploadAudioInVoiceClone}
                dragCallback={_dragCallback}
                disabled={isUploading}
            >
                {isUploading && <FJAutoLoading shown={true} strokeColor='#9FA2AF' />}
                {!isUploading && (
                    <>
                        <FJUploadIcon />
                        <div className={styles.desc}>{FJLocalStore._('drag-or-drop-files-here')}</div>
                        <div className={styles.note}>{FJLocalStore._('files-spported-mp3-wav-mp4')}</div>
                        <FJButton className={styles.btn} type='gradient' text='browse-files' icon={<FJBrowseIcon />} />
                        <div className={styles.btn_outer}>
                            <FJBorderButton
                                className={classNames(styles.btn, styles.record)}
                                type='white'
                                text='record-voice-1'
                                icon={<FJRecordIcon />}
                                onClick={_openRecord}
                            />
                        </div>
                    </>
                )}
                <div className={styles.upload_border_box}>
                    <FJUploadBorderIcon className={styles.upload_border} />
                    <FJUploadBorderHoverIcon className={styles.upload_border_hover} />
                </div>
            </FJFileUpload>
        </>
    );
};

FJUploadAudioToClone.propTypes = {
    uploadAudioInVoiceClone: PropTypes.func,
    openRecord: PropTypes.func,
    onBack: PropTypes.func,
    hasHistoryList: PropTypes.bool,
    isUploading: PropTypes.bool,
};
export default FJUploadAudioToClone;
